__turbopack_context__.v({
  "container": "x3b6yW_container",
  "scrollText": "x3b6yW_scrollText",
  "scrollWrapper": "x3b6yW_scrollWrapper",
  "textContent": "x3b6yW_textContent",
});
